import React, { useEffect, useState } from "react";
import MyStatefulEditor from "./rte_test";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  customEditor: {
    "& [class*='EditorToolbar__root']": {
      margin: "0",
      padding: "10px",
      background: "#F9FAFB",
      "& [class*='ButtonGroup__root']": {
        margin: "0 5px",
        "& [class*='ButtonWrap__root'], & [class*='Dropdown__root']": {
          "& [class*='Button__root']": {
            border: "none",
          },
        },
      },
    },
    "& [class*='RichTextEditor__root']": {
      height: "205px",
      overflow: "hidden",
    },
    "& [class*='RichTextEditor__editor']": {
      overflow: "hidden",
      height: "150px",
      "& .DraftEditor-editorContainer": {
        fontFamily: "Inter",
        fontSize: "14px",
        lineHeight: "200%",
        height: "130px",
        overflow: "hidden",
        padding: "10px 0",
      },
    },
  },
});

export default function TextEditor({ data, setData, id , limitExceeded, isLimitExceeded}) {
  const classes = useStyles();
  // Initialize the state with the initial value from data
  const [val, setVal] = useState(data[id] || "");
  const [description, setDescription] = useState("");

  const onChange = (value) => {
    const maxChars = 2000;
    if (description.length <= maxChars) {
      setVal(value);
      setData((prev) => ({ ...prev, [id]: value }));
    }
  };

  useEffect(() => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = data[id] || "";
    const textContent = tempElement.textContent || tempElement.innerText || "";

    // Update the value whenever data[id] changes
    setVal(data[id] || "");
    setDescription(textContent);
  }, [data[id]]);

  return (
    <div className={`App ${classes.customEditor}`}>
      <MyStatefulEditor
        markup={val}
        onChange={onChange}
        setDescription={setDescription}
        isLimitExceeded={isLimitExceeded}
      />
      <div
        style={{
          fontSize: "12px",
          color: limitExceeded ? "red" : "#6B7280",
          textAlign: "end",
        }}
      >
        {description.length <= 2000 ? description.length : 2000} / 2000
      </div>
    </div>
  );
}
